import React, { useState } from 'react';
import TextInput, {
  InputProps,
} from '@havenengineering/module-shared-library/dist/form/components/TextInput';

const PasswordInput = React.forwardRef((props: InputProps, ref: React.Ref<HTMLInputElement>) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextInput
      {...props}
      ref={ref}
      showPassword={showPassword}
      setShowPassword={setShowPassword}
      type={showPassword ? 'text' : 'password'}
    />
  );
});

export default PasswordInput;
